import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import { IProps } from './ViolatedFilenameDialog';

export const renderViolatedFilenameDialog = (data: IProps) => openPopupHelper<IProps>({ popupName: popupNames.VIOLATED_FILENAME, data });
